module.exports = __webpack_public_path__ + "img/5.9beab0aa.png";